module.exports = __webpack_public_path__ + "static/media/LandingLogo.282c471d.gif";